import api from './api';

export const trusteeRolesAPI = {
  getAvailablePermissions: async () => {
    const response = await api.get('/api/trustee-roles/permissions');
    return response.data;
  },

  getRoleStats: async () => {
    const response = await api.get('/api/trustee-roles/stats');
    return response.data;
  },

  getRoles: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/api/trustee-roles?${params.toString()}`);
    return response.data;
  },

  createRole: async (roleData) => {
    const response = await api.post('/api/trustee-roles', roleData);
    return response.data;
  },

  getRoleById: async (roleId) => {
    const response = await api.get(`/api/trustee-roles/${roleId}`);
    return response.data;
  },

  updateRole: async (roleId, updateData) => {
    const response = await api.put(`/api/trustee-roles/${roleId}`, updateData);
    return response.data;
  },

  deleteRole: async (roleId) => {
    const response = await api.delete(`/api/trustee-roles/${roleId}`);
    return response.data;
  },

  assignRoleToSubAccount: async (roleId, subAccountId) => {
    const response = await api.post('/api/trustee-roles/assign', {
      roleId,
      subAccountId
    });
    return response.data;
  },

  removeRoleFromSubAccount: async (subAccountId) => {
    const response = await api.delete(`/api/trustee-roles/assign/${subAccountId}`);
    return response.data;
  },

  getPendingRoleApprovals: async () => {
    const response = await api.get('/api/trustee-roles/pending-approvals');
    return response.data;
  },

  getRoleApprovalHistory: async () => {
    const response = await api.get('/api/trustee-roles/approval-history');
    return response.data;
  },

  approveRole: async (roleId, approvalData) => {
    const response = await api.post(`/api/trustee-roles/${roleId}/approve`, approvalData);
    return response.data;
  },
};

